import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { COUNTRIES } from "../constant/country";
import { formAddressApi, fromAddress } from '../lib/geocode';
import Select from "react-select";
import Creatable from 'react-select/creatable';
import { GroupAction, UserAction, AuthAction } from "../redux/action";
import { getRegion } from "../constant/country";
import Loader from "./Loader";
import { history } from "../history";

const SignUpStep2 = ({ userData, officeData, setOfficeData, htmlContents, goPrevStep, goNextStep, CreateGroup, CreateUser }) => {
    const [errorMsg, setErrorMsg] = useState('');    
    const [officeList, setOfficeList] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        document.getElementsByTagName('footer')[0].style.display = 'none';
     }, []);

    useEffect(() => {
        const countryCode = officeData.countryCode;
        if (countryCode) {
            GroupAction.GetAllGroupsByCountryCode(countryCode).then(response => {
                if (response.status === 'success')
                    setOfficeList(response.data);                    
                else
                    setOfficeList([]);
            });
        } else {
            setOfficeList([]);
        }
    }, [officeData.countryCode])

    const handleData = (e) => {
        setOfficeData({ ...officeData, [e.target.name]: e.target.value });
    }

    const changeCountryCode = (e) => {
        const countryCode = e.value;
        const region = getRegion(countryCode)?.region || '';

        setOfficeData({ ...officeData, type: '', countryCode, _id: '', name: '', address: '', postalCode: '', tel: '', region });
    }

    const selectOffice = (e) => {
        const filtered = officeList.find(x => x._id === e.value);
        if (filtered) {
            setOfficeData({
                ...officeData,
                type: 'SELECT',
                _id: filtered._id,
                name: filtered.name,
                address: filtered.address,
                postalCode: filtered.postalCode,
                tel: filtered.tel,                
            });            
        }
    }

    const onCreateOption = (value) => {        
        setOfficeList([...officeList, { _id: value, name: value }]);
        setOfficeData({ ...officeData, type: 'CREATE', _id: value, name: value, address: '', postalCode: '', tel: '' });
    }

    const getCoords = async () => {
        const countryCode = officeData.countryCode;
        const address = officeData.address;

        let coords;

        if (countryCode === 'CN' || countryCode === 'HK') {
            const apiDomain = 'https://api-ap-east-1-user.rayteams.com';
            const language = 'zh-' + officeFormData.countryCode;
            const geocodeRet = await formAddressApi(address, language, apiDomain);
            coords = geocodeRet.coords;
        } else {
            let response;
            try {
                response = await fromAddress(address);
            } catch (error) {

            }
            coords = response?.coords;
        }

        return coords;
    }

    const createIuBendaConsent = async () => {
        const formData = {
            subject: {
                email: userData.email,
                full_name: userData.name
            },
            proofs: [
                {
                    content: htmlContents.terms,
                    form: "terms form"
                },
                {
                    content: htmlContents.policy,
                    form: "user form"
                }
            ],
            ip_address: window?.localStorage?.getItem('RAYLINK_LOCALIP')
        };
        await AuthAction.CreateIuBendaConsent(formData);
    };

    const signUp = async () => {

        setShowLoader(true);

        if (officeData.type == "SELECT") {
            const ret = await CreateUser({
                ...userData,
                countryCode: officeData.countryCode,
                region: officeData.region,
                groupId: officeData._id,
                grouptype: officeData.grouptype ?? [],
                type: ['user']
            });

            if (ret.status === 'success') {
                await GroupAction.UpdateHasMember(officeData._id, true, officeData.region);
                await createIuBendaConsent();
            } else {
                setErrorMsg(ret.error);
            }
        }

        if (officeData.type == "CREATE") {
            const coords = await getCoords();

            if (coords) {
                setOfficeData({ ...officeData, coords: [coords.lng, coords.lat] });

                const { type, ...data } = officeData;

                const response = await CreateGroup(data);

                if (response.status === 'success') {
                    const uLen = await UserAction.GetUserIdsByGroupIdNoAuth(response.data._id, response.data.region);

                    const ret = await CreateUser({
                        ...userData,
                        countryCode: response.data.countryCode,
                        region: response.data.region,
                        groupId: response.data._id,
                        grouptype: response.data.grouptype ?? [],
                        type: [uLen.data.length > 0 ? 'user' : 'manager']
                    });

                    if (ret.status === 'success') {
                        console.log('success');
                        await GroupAction.UpdateHasMember(response.data._id, true, userData.region);
                        await createIuBendaConsent();
                        goNextStep();
                    } else {
                        setErrorMsg(ret.error);
                    }
                }
            } else {
                setErrorMsg('Not find address coords. Please re-enter your address.');
                setShowLoader(false);
                return;
            }
        }

        setShowLoader(false);
    }

    return (
        <>
            <div className="content-wrapper rt-site image-wrapper bg-image bg-overlay bg-overlay-400 bg-content" data-image-src="/assets/img/bg_signin.jpg" style={{ backgroundImage: 'url(/assets/img/bg_signin.jpg)', height: '100%' }}>
                <section className="wrapper text-white">
                    <div className="container pt-10 pb-8 pt-md-18 pb-md-11 signin" style={{ zIndex: 5, position: 'relative' }}>
                        <div className="row gx-0 gy-8">
                            <div className="col-md-10 offset-md-1 offset-lg-0 col-lg-6 content text-center text-lg-start pt-md-21 signin-logo" data-cues="slideInDown" data-group="page-title" data-delay="600" data-disabled="true">
                                <a href="#" onClick={(e) => { e.preventDefault(); history.push('/') }}>
                                    <img src="/assets/img/bi_rayteams_light.svg" className="mb-5" alt="RAYTeams" data-cue="slideInDown" data-group="page-title" data-delay="600" data-show="true" style={{
                                        animationName: 'slideInDown',
                                        animationDuration: '700ms',
                                        animationTimingFunction: 'ease',
                                        animationDelay: '600ms',
                                        animationDirection: 'normal',
                                        animationFillMode: 'both'
                                    }} />
                                </a>
                                <p className="lead fs-lg lh-sm" data-cue="slideInDown" data-group="page-title" data-delay="600" data-show="true" style={{
                                    animationName: 'slideInDown',
                                    animationDuration: '700ms',
                                    animationTimingFunction: 'ease',
                                    animationDelay: '900ms',
                                    animationDirection: 'normal',
                                    animationFillMode: 'both'
                                }}>Log in or <span className="underline-2 violet">sign up</span> for RAYTeams.<br />One account for RAYTeams Cloud and client.</p>
                            </div>
                            <div className="col-lg-5 offset-lg-1 signup">
                                <div className="card">
                                    <div className="card-body p-11 text-center text-dark">
                                        <h2 className="mb-5 text-start">Sign up <span className="badge bg-primary rounded-pill float-end signup-step">2/2</span><span className="float-end h6 signup-step text-primary">Institute Information</span></h2>
                                        <form className="text-start mb-3">
                                            <div className="form-select-wrapper mb-4">
                                                <Select
                                                    options={COUNTRIES.map(x => { return { label: x.name, value: x.countryCode } })}
                                                    placeholder="Country *"
                                                    onChange={changeCountryCode}
                                                    styles={{
                                                        control: (styles) => ({
                                                            ...styles,
                                                            border: '1px solid rgba(8, 60, 130, 0.07)',
                                                            height: '52px',
                                                            backgroundColor: '#fefefe',
                                                            fontSize: '0.75rem',
                                                            fontWeight:'500 !important',
                                                            color: '#60697b !important',
                                                            borderRadius: '0.4rem',
                                                            boxShadow: '0rem 0rem 1.25rem rgb(30 34 40 / 4%)',
                                                            transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;'
                                                        }),
                                                    }}
                                                    value={COUNTRIES.filter(x => x.countryCode === officeData.countryCode).map(z => { return { label: z.name, value: z.countryCode } })}
                                                />
                                            </div>
                                            <div className="form-floating mb-4">
                                                <Creatable
                                                    options={officeList.map(x => { return { label: x.name, value: x._id } })}
                                                    placeholder="Institute Name *"
                                                    value={!officeData.name && !officeData._id ? '' : { label: officeData.name, value: officeData._id }}
                                                    onChange={selectOffice}
                                                    onCreateOption={onCreateOption}
                                                    styles={{
                                                        control: (styles) => ({
                                                            ...styles,
                                                            border: '1px solid rgba(8, 60, 130, 0.07)',
                                                            height: '52px',
                                                            backgroundColor: '#fefefe',
                                                            fontSize: '0.75rem',
                                                            fontWeight:'500 !important',
                                                            color: '#60697b !important',
                                                            borderRadius: '0.4rem',
                                                            boxShadow: '0rem 0rem 1.25rem rgb(30 34 40 / 4%)',
                                                            transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;'
                                                        }),
                                                    }}                                                    
                                                />
                                            </div>
                                            <div className="form-floating mb-4">
                                                <input type="text" className="form-control" placeholder="address" name="address" id="address" onChange={handleData} value={officeData.address} disabled={officeData.type === "SELECT"} />
                                                    <label htmlFor="address">address *</label>
                                            </div>
                                            <div className="form-floating mb-4">
                                                <input type="text" className="form-control" placeholder="Zip Code" name="postalCode" id="postalCode" onChange={handleData} value={officeData.postalCode} disabled={officeData.type === "SELECT"} />
                                                    <label htmlFor="postalCode">Zip Code</label>
                                            </div>

                                            <div className="form-floating mb-4">
                                                <input type="text" className="form-control" placeholder="Tel" name="tel" id="tel" onChange={handleData} value={officeData.tel} disabled={officeData.type === "SELECT"} />
                                                    <label htmlFor="tel">Tel</label>
                                            </div>

                                            {
                                                errorMsg && <p className="text-danger mt-n2">{errorMsg}</p>
                                            }
                                            
                                            <div className="row">
                                                <div className="col-12 col-md-3 order-1">
                                                    <a className="btn btn-soft-primary rounded-pill btn-login w-100 mb-3" onClick={() => goPrevStep()}>Prev</a>
                                                </div>
                                                <div className="col-12 col-md-9 order-2">
                                                    <a className="btn btn-primary rounded-pill btn-login w-100 mb-3" onClick={() => signUp()}>Sign Up</a>
                                                </div>
                                            </div>

                                            <p className="mb-3 text-start mb-n2">Already have an account? <a href="/login" className="hover">Login now.</a></p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Loader isShow={showLoader} />
            </div>
        </>
    )
}

const mapState = (state) => {
	return {};
};

const mapDispatch = dispatch => ({
    CreateGroup: (data) => dispatch(GroupAction.CreateWithoutAuth(data)),
	CreateUser: (data) => dispatch(UserAction.CreateWithoutAuth(data))
})

export default connect(mapState, mapDispatch)(SignUpStep2);